const csvContent = [
  ['id', 'name', 'quantity'],
  [1, 'Product A', 10],
  [2, 'Product B', 5],
  [3, 'Product C', 20],
]
  .map(row => row.join(';')) // in Italian Excel the separator is ';', otherwise in English it's ','
  .join('\n');

export const SAMPLE_CSV = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
